export const TEAMS = 'teams';

// deal sidebar tabs
export const DEALS_TAB = 'DEALS';
export const GOALS_TAB = 'GOALS';